import React, { useEffect } from 'react';
import { Fragment, useState } from 'react';
import { Switch } from '@headlessui/react';
import {
  Form,
  Link,
  useActionData,
  useNavigate,
  useNavigation,
} from 'react-router-dom';
import { Dialog, Transition } from '@headlessui/react';
import { toast } from 'react-toastify';
import { XMarkIcon } from '@heroicons/react/24/outline';
import customFetch from '../../utils/customFetch';
import { useCartContext } from '../../context/cartContext';
import { InformationCircleIcon } from '@heroicons/react/20/solid';
import QrCode from './QrCode';

export const action = async ({ request }) => {
  const formData = await request.formData();
  console.log(formData);

  const graphicFront = formData.get('graphicFront');
  const graphicBack = formData.get('graphicBack');

  if (graphicFront && graphicFront.size > 5000000) {
    toast.error('Das Bild der Vorderseite darf nicht grösser als 5MB sein');
    return null;
  }

  if (graphicBack && graphicBack.size > 5000000) {
    toast.error('Das Bild der Rückseite darf nicht grösser als 5MB sein');
    return null;
  }

  try {
    const response = await customFetch.post('/orders/customize', formData);
    toast.success('Erfolgreich hochgeladen!');
    return response;
  } catch (error) {
    toast.error(error?.response?.data?.msg);
    return error;
  }
};

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const ProductCustomizationSlideIn = ({
  showSlideIn,
  changeSlideIn,
  product,
}) => {
  const navigation = useNavigation();
  const isSubmitting = navigation.state === 'submitting';
  // Zum Warenkorb erst freischalten, wenn Bilder hochgeladen
  const { addToCart } = useCartContext();
  const [pictureUploaded, setPictureUploaded] = useState(false);
  const response = useActionData();
  useEffect(() => {
    if (response !== undefined) {
      setPictureUploaded(true);
      console.log(response);
    }
  });

  // Image preview Front
  const [selectedFileFront, setSelectedFileFront] = useState();
  const [previewFront, setpreviewFront] = useState();
  // create a preview as a side effect, whenever selected file is changed
  useEffect(() => {
    if (!selectedFileFront) {
      setpreviewFront(undefined);
      return;
    }

    const objectUrlFront = URL.createObjectURL(selectedFileFront);
    setpreviewFront(objectUrlFront);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrlFront);
  }, [selectedFileFront]);

  const onSelectFileFront = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFileFront(undefined);
      return;
    }

    // I've kept this example simple by using the first image instead of multiple
    setSelectedFileFront(e.target.files[0]);
  };

  // Image preview Back
  const [selectedFileBack, setSelectedFileBack] = useState();
  const [previewBack, setpreviewBack] = useState();
  // create a preview as a side effect, whenever selected file is changed
  useEffect(() => {
    if (!selectedFileBack) {
      setpreviewBack(undefined);
      return;
    }

    const objectUrlBack = URL.createObjectURL(selectedFileBack);
    setpreviewBack(objectUrlBack);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrlBack);
  }, [selectedFileBack]);

  const onSelectFileBack = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFileBack(undefined);
      return;
    }

    // I've kept this example simple by using the first image instead of multiple
    setSelectedFileBack(e.target.files[0]);
  };

  // User from local storage
  const userObject = localStorage.getItem('user');
  let user;
  if (userObject) {
    user = JSON.parse(userObject);
    if (user.timestamp) {
      const storedTimestamp = new Date(user.timestamp);
      const currentTime = new Date();

      const timeDifference = currentTime - storedTimestamp;

      const oneDayInMs = 24 * 60 * 60 * 1000;

      if (timeDifference < oneDayInMs) {
        user.ok = true;
      } else {
        user.ok = false;
      }
    } else {
      console.log('Kein Timestamp gefunden.');
    }
  }

  // Auswahl Bild oder Farbe
  const [bildOderFarbeFront, setBildOderFarbeFront] = useState('bild');
  const [colorFront, setColorFront] = useState('#D90000');
  const handleColorChangeFront = (event) => {
    setColorFront(event.target.value);
  };
  const [QRCodeFront, setQRCodeFront] = useState(false);
  const [QRCodeFrontColor, setQRCodeFrontColor] = useState('#FFFFFF');
  const handleQRColorChangeFront = (event) => {
    setQRCodeFrontColor(event.target.value);
  };

  const [bildOderFarbeBack, setBildOderFarbeBack] = useState('bild');
  const [colorBack, setColorBack] = useState('#D90000');
  const handleColorChangeBack = (event) => {
    setColorBack(event.target.value);
  };
  const [QRCodeBack, setQRCodeBack] = useState(false);
  const [QRCodeBackColor, setQRCodeBackColor] = useState('#FFFFFF');
  const handleQRColorChangeBack = (event) => {
    setQRCodeBackColor(event.target.value);
  };

  // Reset Slide-in when closed
  const closeAndResetSlideIn = () => {
    changeSlideIn();
    setSelectedFileBack(undefined);
    setpreviewBack(undefined);
    setSelectedFileFront(undefined);
    setpreviewFront(undefined);
    setBildOderFarbeFront('bild');
    setBildOderFarbeBack('bild');
    setPictureUploaded(false);
    setQRCodeFront(false);
    setQRCodeBack(false);
    setQRCodeFrontColor('#FFFFFF');
    setQRCodeBackColor('#FFFFFF');
  };

  // Check ob Bild ausgewählt und vorhanden, sonst Button disabeln

  const isButtonDisabled = () => {
    // If both are "farbe" then proceed

    if (bildOderFarbeFront === 'farbe' && bildOderFarbeBack === 'farbe') {
      return false; // Enable button
    }

    // Check if both front and back are 'bild' and both pictures are uploaded
    if (
      bildOderFarbeFront === 'bild' &&
      bildOderFarbeBack === 'bild' &&
      previewBack &&
      previewFront
    ) {
      return false; // Enable button
    }

    // Check if front is 'farbe' and back is 'bild' and picture is uploaded
    if (
      bildOderFarbeFront === 'farbe' &&
      bildOderFarbeBack === 'bild' &&
      previewBack
    ) {
      return false; // Enable button
    }

    // Check if back is 'farbe' and front is 'bild' and picture is uploaded
    if (
      bildOderFarbeBack === 'farbe' &&
      bildOderFarbeFront === 'bild' &&
      previewFront
    ) {
      return false; // Enable button
    }

    // Disable button if none of the conditions are met
    return true;
  };

  // Weiterleiten, wenn zu Warenkorb hinzugefügt
  let navigate = useNavigate();
  const addAndGoToCart = () => {
    // Switch, ob Bild oder Farbe
    let front = '';
    let back = '';

    if (bildOderFarbeFront === 'farbe') {
      front = JSON.stringify({
        Farbe: colorFront,
        QR_Code: QRCodeFront,
        QR_Code_Farbe: QRCodeFrontColor,
      });
    } else {
      front = response.data.data[0].graphicFront.url;
    }
    if (bildOderFarbeBack === 'farbe') {
      back = JSON.stringify({
        Farbe: colorBack,
        QR_Code: QRCodeBack,
        QR_Code_Farbe: QRCodeBackColor,
      });
    } else {
      if (response.data.data[1] && response.data.data[1].graphicBack) {
        back = response.data.data[1].graphicBack.url;
      } else if (response.data.data[0] && response.data.data[0].graphicBack) {
        back = response.data.data[0].graphicBack.url;
      } else {
        back = ''; // Fallback in case no graphicBack is available
      }
    }

    addToCart(product, 1, front, back);
    navigate('/warenkorb');
  };

  return (
    <Transition.Root show={showSlideIn} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={closeAndResetSlideIn}>
        <div className="fixed inset-0" />

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                  <Form
                    method="POST"
                    className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl"
                    encType="multipart/form-data"
                  >
                    <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
                      <div className="px-4 sm:px-6">
                        <div className="flex items-start justify-between">
                          <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
                            Produkt individualisieren
                            {/* Aufforderung zum Einloggen, wenn nicht eingeloggt */}
                            {user?.ok === true ? (
                              ''
                            ) : (
                              <div className="rounded-md bg-blue-50 p-4 my-4 font-normal">
                                <div className="flex">
                                  <div className="shrink-0">
                                    <InformationCircleIcon
                                      className="h-5 w-5 text-blue-400"
                                      aria-hidden="true"
                                    />
                                  </div>
                                  <div className="ml-3 flex-1 md:flex md:justify-between">
                                    <p className="text-sm text-blue-700">
                                      Logge dich ein, damit du deine
                                      individualisierte sVisit-Karte erstellen
                                      kannst.
                                    </p>
                                    <p className="mt-3 text-sm md:ml-6 md:mt-0">
                                      <Link
                                        to="/login?redirectURL=/produkte/65db4f9319422cfaf902c455"
                                        className="whitespace-nowrap font-medium text-blue-700 hover:text-blue-600"
                                      >
                                        Einloggen
                                        <span aria-hidden="true"> &rarr;</span>
                                      </Link>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )}
                            <p className="text-gray-500 font-normal">
                              Für eine optimale Druckqualität empfehlen wir eine
                              Auflösung von mindestens 1586 x 1000 Pixel. Hast
                              du Spezialwünsche für dein Design? Schreibe uns
                              unter info@svisit.ch und wir helfen dir gerne
                              weiter!
                            </p>
                          </Dialog.Title>

                          <div className="ml-3 flex h-7 items-center">
                            <button
                              type="button"
                              className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-hidden focus:ring-2 focus:ring-svisit-primary-500"
                              onClick={closeAndResetSlideIn}
                            >
                              <span className="absolute -inset-2.5" />
                              <span className="sr-only">Close panel</span>
                              <XMarkIcon
                                className="h-6 w-6"
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="relative mt-6 flex-1 px-4 sm:px-6">
                        {/* Produkt Individualisierung Start */}
                        <div
                          className={`flex h-full flex-col ${
                            user?.ok === true
                              ? ''
                              : 'opacity-50 cursor-not-allowed'
                          }`}
                        >
                          {/* Auswahl, ob Bild oder Farbe */}
                          <div className="sm:col-span-4">
                            <p className="block text-sm font-medium leading-6 text-gray-900">
                              Möchtest du ein Bild oder nur eine Farbe auf der
                              Vorderseite?
                            </p>
                            <fieldset className="my-4">
                              <div className="mt-2 space-y-4 sm:flex sm:items-center sm:space-x-10 sm:space-y-0">
                                <div className="flex items-center">
                                  <input
                                    id="bild"
                                    name="bildOderFarbeFront"
                                    type="radio"
                                    value="bild"
                                    defaultChecked={
                                      bildOderFarbeFront === 'bild'
                                    }
                                    onChange={() =>
                                      setBildOderFarbeFront('bild')
                                    }
                                    className="h-4 w-4 border-gray-300 text-svisit-primary-600 focus:ring-svisit-primary-600"
                                  />
                                  <label
                                    htmlFor="bild"
                                    className="ml-3 block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Bild
                                  </label>
                                </div>
                                <div className="flex items-center">
                                  <input
                                    id="farbe"
                                    name="bildOderFarbeFront"
                                    type="radio"
                                    value="farbe"
                                    defaultChecked={
                                      bildOderFarbeFront === 'farbe'
                                    }
                                    onChange={() =>
                                      setBildOderFarbeFront('farbe')
                                    }
                                    className="h-4 w-4 border-gray-300 text-svisit-primary-600 focus:ring-svisit-primary-600"
                                  />
                                  <label
                                    htmlFor="farbe"
                                    className="ml-3 block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Farbe
                                  </label>
                                </div>
                              </div>
                            </fieldset>
                          </div>
                          {/* Case Switch, ob Bild oder Farbe */}
                          {bildOderFarbeFront === 'farbe' ? (
                            <>
                              {/* Farbe und QR Code Vorderseite Start */}
                              <div className="sm:col-span-6 border-b border-gray-900/10 pb-5">
                                <div className="sm:col-span-4">
                                  <label
                                    htmlFor="farbeFront"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Farbe für die Vorderseite auswählen
                                  </label>
                                  <div className="my-2">
                                    <input
                                      type="color"
                                      name="farbeFront"
                                      id="farbeFront"
                                      defaultValue="#D90000"
                                      onChange={handleColorChangeFront}
                                    />
                                  </div>
                                </div>
                                <div className="max-w-2xl">
                                  <div className="aspect-[1.586/1]">
                                    <div
                                      className="h-full w-full flex-none rounded-lg grid place-items-center"
                                      style={{ backgroundColor: colorFront }}
                                    >
                                      <div className="w-1/3">
                                        {QRCodeFront ? (
                                          <QrCode color={QRCodeFrontColor} />
                                        ) : (
                                          ''
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="sm:col-span-4 my-2">
                                  <p className="block text-sm font-medium leading-6 text-gray-900">
                                    QR-Code
                                  </p>
                                  <div className="mt-2">
                                    <Switch
                                      checked={QRCodeFront}
                                      onChange={setQRCodeFront}
                                      className={classNames(
                                        QRCodeFront
                                          ? 'bg-svisit-primary-600'
                                          : 'bg-gray-200',
                                        'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-hidden focus:ring-2 focus:ring-svisit-primary-600 focus:ring-offset-2'
                                      )}
                                    >
                                      <span className="sr-only">
                                        QR Code auf Vorderseite abdrucken?
                                      </span>
                                      <span
                                        aria-hidden="true"
                                        className={classNames(
                                          QRCodeFront
                                            ? 'translate-x-5'
                                            : 'translate-x-0',
                                          'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out'
                                        )}
                                      />
                                      <input
                                        type="hidden"
                                        name="QRCodeFront"
                                        id="QRCodeFront"
                                        defaultValue={QRCodeFront}
                                      />
                                    </Switch>
                                    {QRCodeFront ? (
                                      <div className="mt-2">
                                        <label
                                          htmlFor="graphicFront"
                                          className="block text-sm font-medium leading-6 text-gray-900"
                                        >
                                          Farbe für QR-Code
                                        </label>
                                        <div className="my-2">
                                          <input
                                            type="color"
                                            name="QRCodeFrontColor"
                                            id="QRCodeFrontColor"
                                            defaultValue="#FFFFFF"
                                            onChange={handleQRColorChangeFront}
                                          />
                                        </div>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                </div>
                              </div>
                              {/* Farbe und QR Code Vorderseite Ende */}
                            </>
                          ) : (
                            <>
                              {/* Bild Vorderseite Start */}
                              <div className="sm:col-span-6 border-b border-gray-900/10 pb-5">
                                <div className="block text-sm font-medium leading-6 text-gray-900">
                                  Bild für die Vorderseite hochladen
                                </div>
                                <div className="max-w-2xl">
                                  <div className="aspect-[1.586/1]">
                                    {selectedFileFront ? (
                                      <img
                                        src={previewFront}
                                        alt="graphicFront"
                                        className="h-full w-full flex-none rounded-lg object-cover"
                                      />
                                    ) : (
                                      <img
                                        src="https://res.cloudinary.com/djvqy2bag/image/upload/v1710590577/Nur_Hinterseite_weiss_htz3fm.png"
                                        alt="graphicFront"
                                        className="h-full w-full flex-none rounded-lg object-cover"
                                      />
                                    )}
                                  </div>
                                </div>
                                {pictureUploaded ? (
                                  ''
                                ) : (
                                  <>
                                    <div className="mt-2">
                                      <div className="mt-4 flex text-sm leading-6 text-gray-600">
                                        <button
                                          type="button"
                                          className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs hover:bg-gray-50 ring-1 ring-inset ring-gray-300"
                                        >
                                          <label
                                            htmlFor="graphicFront"
                                            className="relative cursor-pointer "
                                          >
                                            Eine Datei hochladen
                                          </label>
                                        </button>
                                      </div>
                                      <p className="text-xs leading-5 text-gray-600 mt-2">
                                        PNG, JPG, SVG bis maximal 5MB
                                      </p>
                                    </div>
                                    <input
                                      id="graphicFront"
                                      name="graphicFront"
                                      type="file"
                                      accept="image/*"
                                      className="sr-only"
                                      onChange={onSelectFileFront}
                                      disabled={!user?.ok}
                                    />
                                  </>
                                )}
                              </div>
                              {/* Bild Vorderseite Ende */}
                            </>
                          )}

                          {/* Auswahl, ob Bild oder Farbe */}
                          <div className="sm:col-span-4">
                            <p className="block text-sm font-medium leading-6 text-gray-900">
                              Möchtest du ein Bild oder nur eine Farbe auf der
                              Rückseite?
                            </p>
                            <fieldset className="my-4">
                              <div className="mt-2 space-y-4 sm:flex sm:items-center sm:space-x-10 sm:space-y-0">
                                <div className="flex items-center">
                                  <input
                                    id="bildB"
                                    name="bildOderFarbeBack"
                                    type="radio"
                                    value="bild"
                                    defaultChecked={
                                      bildOderFarbeBack === 'bild'
                                    }
                                    onChange={() =>
                                      setBildOderFarbeBack('bild')
                                    }
                                    className="h-4 w-4 border-gray-300 text-svisit-primary-600 focus:ring-svisit-primary-600"
                                  />
                                  <label
                                    htmlFor="bildB"
                                    className="ml-3 block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Bild
                                  </label>
                                </div>
                                <div className="flex items-center">
                                  <input
                                    id="farbeB"
                                    name="bildOderFarbeBack"
                                    type="radio"
                                    value="farbe"
                                    defaultChecked={
                                      bildOderFarbeBack === 'farbe'
                                    }
                                    onChange={() =>
                                      setBildOderFarbeBack('farbe')
                                    }
                                    className="h-4 w-4 border-gray-300 text-svisit-primary-600 focus:ring-svisit-primary-600"
                                  />
                                  <label
                                    htmlFor="farbeB"
                                    className="ml-3 block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Farbe
                                  </label>
                                </div>
                              </div>
                            </fieldset>
                          </div>
                          {/* Case Switch, ob Bild oder Farbe */}
                          {bildOderFarbeBack === 'farbe' ? (
                            <>
                              {/* Farbe und QR Code Rückseite Start */}
                              <div className="sm:col-span-6 border-b border-gray-900/10 pb-5">
                                <div className="sm:col-span-4">
                                  <label
                                    htmlFor="farbeBack"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Farbe für die Vorderseite auswählen
                                  </label>
                                  <div className="my-2">
                                    <input
                                      type="color"
                                      name="farbeBack"
                                      id="farbeBack"
                                      defaultValue="#D90000"
                                      onChange={handleColorChangeBack}
                                    />
                                  </div>
                                </div>
                                <div className="max-w-2xl">
                                  <div className="aspect-[1.586/1]">
                                    <div
                                      className="h-full w-full flex-none rounded-lg grid place-items-center"
                                      style={{ backgroundColor: colorBack }}
                                    >
                                      <div className="w-1/3">
                                        {QRCodeBack ? (
                                          <QrCode color={QRCodeBackColor} />
                                        ) : (
                                          ''
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="sm:col-span-4 my-2">
                                  <p className="block text-sm font-medium leading-6 text-gray-900">
                                    QR-Code
                                  </p>
                                  <div className="mt-2">
                                    <Switch
                                      checked={QRCodeBack}
                                      onChange={setQRCodeBack}
                                      className={classNames(
                                        QRCodeBack
                                          ? 'bg-svisit-primary-600'
                                          : 'bg-gray-200',
                                        'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-hidden focus:ring-2 focus:ring-svisit-primary-600 focus:ring-offset-2'
                                      )}
                                    >
                                      <span className="sr-only">
                                        QR Code auf Rückseite abdrucken?
                                      </span>
                                      <span
                                        aria-hidden="true"
                                        className={classNames(
                                          QRCodeBack
                                            ? 'translate-x-5'
                                            : 'translate-x-0',
                                          'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out'
                                        )}
                                      />
                                      <input
                                        type="hidden"
                                        name="QRCodeBack"
                                        id="QRCodeBack"
                                        defaultValue={QRCodeBack}
                                      />
                                    </Switch>
                                    {QRCodeBack ? (
                                      <div className="mt-2">
                                        <label
                                          htmlFor="graphicBack"
                                          className="block text-sm font-medium leading-6 text-gray-900"
                                        >
                                          Farbe für QR-Code
                                        </label>
                                        <div className="my-2">
                                          <input
                                            type="color"
                                            name="QRCodeBackColor"
                                            id="QRCodeBackColor"
                                            defaultValue="#FFFFFF"
                                            onChange={handleQRColorChangeBack}
                                          />
                                        </div>
                                      </div>
                                    ) : (
                                      ''
                                    )}
                                  </div>
                                </div>
                              </div>
                              {/* Farbe und QR Code Vorderseite Ende */}
                            </>
                          ) : (
                            <>
                              {/* Bild für Rückseite Start */}
                              <div className="sm:col-span-6 pt-5">
                                <div className="block text-sm font-medium leading-6 text-gray-900">
                                  Bild für die Rückseite hochladen
                                </div>
                                <div className="max-w-2xl">
                                  <div className="aspect-[1.586/1] overflow-hidden">
                                    {selectedFileBack ? (
                                      <img
                                        src={previewBack}
                                        alt="graphicBack"
                                        className="h-full w-full flex-none rounded-lg object-cover"
                                      />
                                    ) : (
                                      <img
                                        src="https://res.cloudinary.com/djvqy2bag/image/upload/v1710590577/Nur_Hinterseite_weiss_htz3fm.png"
                                        alt="graphicBack"
                                        className="h-full w-full flex-none rounded-lg object-cover"
                                      />
                                    )}
                                  </div>
                                </div>
                                {pictureUploaded ? (
                                  ''
                                ) : (
                                  <>
                                    <div className="mt-2">
                                      <div className="mt-4 flex text-sm leading-6 text-gray-600">
                                        <button
                                          type="button"
                                          className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs hover:bg-gray-50 ring-1 ring-inset ring-gray-300"
                                        >
                                          <label
                                            htmlFor="graphicBack"
                                            className="relative cursor-pointer"
                                          >
                                            Eine Datei hochladen
                                          </label>
                                        </button>
                                      </div>
                                      <p className="text-xs leading-5 text-gray-600 mt-2">
                                        PNG, JPG, SVG bis maximal 5MB
                                      </p>
                                    </div>
                                    <input
                                      id="graphicBack"
                                      name="graphicBack"
                                      type="file"
                                      accept="image/*"
                                      className="sr-only"
                                      onChange={onSelectFileBack}
                                      disabled={!user?.ok}
                                    />
                                  </>
                                )}
                              </div>
                              {/* Bild für Rückseite Ende */}
                            </>
                          )}
                        </div>
                        {/* Produkt Individualisierung Ende */}
                      </div>
                    </div>
                    <div className="flex shrink-0 justify-end px-4 py-4">
                      <button
                        type="button"
                        className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
                        onClick={closeAndResetSlideIn}
                      >
                        Abbrechen
                      </button>
                      {pictureUploaded ||
                      (bildOderFarbeFront === 'farbe' &&
                        bildOderFarbeBack === 'farbe') ? (
                        <button
                          onClick={addAndGoToCart}
                          className="ml-4 cursor-pointer inline-flex justify-center rounded-md bg-svisit-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-svisit-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-svisit-primary-500 disabled:bg-gray-300 disabled:hover:cursor-not-allowed"
                          disabled={isButtonDisabled()}
                        >
                          Zum Warenkorb hinzufügen
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="ml-4 inline-flex justify-center rounded-md bg-svisit-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-svisit-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-svisit-primary-500 disabled:bg-gray-300 disabled:hover:cursor-not-allowed"
                          disabled={isSubmitting || isButtonDisabled()}
                        >
                          {isSubmitting ? 'Lädt hoch...' : 'Bilder hochladen'}
                        </button>
                      )}
                    </div>
                  </Form>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ProductCustomizationSlideIn;
